import styled from 'styled-components'
import Warning from '@material-ui/icons/Warning'

export const Container = styled.div``

export const Header = styled.div`
  background-color: #b26a00;
  color: white;
  text-align: center;
  padding: 5px 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 41px;
`

export const HeaderTitle = styled.h1`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`

export const HeaderSubtitle = styled.span`
  font-size: 14px;
  letter-spacing: 0.4px;
`

export const ErrorText = styled.span`
  font-size: 14px;
  letter-spacing: 0.4px;
`

export const WarningIcon = styled(Warning)`
  color: white;
`

export const IconContainer = styled.span`
  position: absolute;
  left: 10px;
  top: 10px;
  pointer-events: none;
`
